import { CountUp } from 'countup.js';
import { isScrolledIntoView } from '../helpers';

export default () => {
  let animated = false;

  const paragraph = document.querySelector('.paragraph--type--market-snapshots');

  function counter() {
    if (!animated && isScrolledIntoView(paragraph)) {
      const counters = document.querySelectorAll('.market-snapshot-item .count');
      counters.forEach(element => {
        const options = {
          duration: 4,
        };
        const endVal = element.getAttribute('data-count-to');
        if (!(endVal % 1 === 0)) {
          options.decimalPlaces = 2;
        }

        const countUp = new CountUp(element, endVal, options);
        countUp.start();
      });
      animated = true;
    }
  }

  window.addEventListener('scroll', function() {
    if (paragraph) {
      counter();
    }
  });
};
